import { render, staticRenderFns } from "./SettingsNavigation.vue?vue&type=template&id=21dd812a&scoped=true"
import script from "./SettingsNavigation.vue?vue&type=script&lang=js"
export * from "./SettingsNavigation.vue?vue&type=script&lang=js"
import style0 from "./SettingsNavigation.vue?vue&type=style&index=0&id=21dd812a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dd812a",
  null
  
)

export default component.exports